import { RxContactsApi } from '@driftt/dapper'
import { Map } from 'immutable'

export const api = {
  /**
   * @deprecated due to archived enrichment-api, see [this PR](https://github.com/Driftt/enrichment-api/pull/278) 
   */
  fetchDemandbaseCompanyData(options = {}) {
    return Map()
  },

  fetchDemandbaseIndustries() {
    return RxContactsApi.get(`/enrichment/demandbase/industries`)
      .checkStatus()
      .map(res => res.response)
  },

  fetchDemandbaseSubIndustries() {
    return RxContactsApi.get(`/enrichment/demandbase/sub_industries`)
      .checkStatus()
      .map(res => res.response)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/api.js